import { Flex, Box, Text } from "@chakra-ui/react"
import moment from "moment"

// Claude: removed Join button — whole row is now clickable to meetings list 13-04-2026
type Props = {
    companyName: string;
    proposedDate: string;
    proposedTime: string;
    onClick: () => void;
}

const MeetingListItem = ( props: Props) => {
    return (
        <Flex alignItems={"center"} justifyContent={"space-between"} cursor="pointer" onClick={props.onClick}>
            <Box>
                <Flex alignItems={"center"} gap={3}>
                    <Text fontSize={"sm"} fontWeight={"medium"}>
                        {props.companyName}
                    </Text>
                </Flex>
                <Text mt={"6px"} fontSize={"xs"}>
                    {moment(props.proposedDate)?.format("DD MMM")}{" "}
                    | {props.proposedTime}
                </Text>
            </Box>
        </Flex>
    );
}


export default MeetingListItem;